import React from 'react';
import BuilderRenderer from '../../components/BuilderRenderer';

const App = (props) => <BuilderRenderer {...props} />;

export default App;
